var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWifiIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4258bf",
    d: "M7 30a7 7 0 0 1-7-7V7a7 7 0 0 1 7-7h16a7 7 0 0 1 7 7v16a7 7 0 0 1-7 7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.463 20.748a1.308 1.308 0 1 1-2.617 0 1.308 1.308 0 0 1 2.617 0zM14.155 7.857c3.906 0 7.44 1.582 10 4.142l-1.237 1.238A12.36 12.36 0 0 0 14.155 9.6a12.36 12.36 0 0 0-8.763 3.636l-1.237-1.238a14.096 14.096 0 0 1 10-4.142zM6.97 14.811a10.131 10.131 0 0 1 7.186-2.976c2.807 0 5.348 1.138 7.187 2.976l-1.237 1.237a8.39 8.39 0 0 0-5.95-2.47 8.39 8.39 0 0 0-5.95 2.47L6.97 14.81zm2.813 2.814a6.169 6.169 0 0 1 4.373-1.812c1.708 0 3.254.693 4.374 1.812l-1.235 1.235a4.427 4.427 0 0 0-3.139-1.303 4.427 4.427 0 0 0-3.139 1.303l-1.234-1.235z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiIcon);
export default __webpack_public_path__ + "static/media/wifi-icon.9a96ecefc970dcbae4fb851cc6e3f516.svg";
export { ForwardRef as ReactComponent };